import { render, staticRenderFns } from "./SuppliyPriceAudit.vue?vue&type=template&id=06cf7bee&scoped=true&lang=pug&"
import script from "./SuppliyPriceAudit.vue?vue&type=script&lang=ts&"
export * from "./SuppliyPriceAudit.vue?vue&type=script&lang=ts&"
import style0 from "./SuppliyPriceAudit.vue?vue&type=style&index=0&id=06cf7bee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cf7bee",
  null
  
)

export default component.exports